"use client";

import { c as _c } from "react/compiler-runtime";
import { useTheme } from "@xefi/x-react/hooks";
import Image from "next/image";
import { useEffect, useState } from "react";
import logoDark from "@/assets/DailyAppsLogoDark.svg";
import logo from "@/assets/DailyAppsLogo.svg";
export const ApplicationLogo = () => {
  const $ = _c(4);
  const [mounted, setMounted] = useState(false);
  const {
    theme
  } = useTheme();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setMounted(true);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  const logoSrc = mounted ? theme === "light" ? logo : logoDark : logo;
  let t2;
  if ($[2] !== logoSrc) {
    t2 = <div className="flex justify-center"><Image priority={true} alt="logo dailyApps" className="w-50" src={logoSrc} /></div>;
    $[2] = logoSrc;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};